import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
//Constants
import {FavoriteAddressInterface} from "@interfaces/orders/favorite-address.interface";
import {CityInterface} from "@interfaces/components/cities.interface";

@Component({
  selector: 'app-bottom-navbar-for-address-selection',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './bottom-navbar-for-address-selection.component.html',
  styleUrl: './bottom-navbar-for-address-selection.component.scss'
})
export class BottomNavbarForAddressSelectionComponent {
  @Input() set selectedData(data: { address: FavoriteAddressInterface } | { city: CityInterface }) {
    if (!data) {
      return;
    }
    this.selectedAddressName = 'address' in data ? data.address.fullAddress : data.city.name;
  };
  @Input() fromTop = false;
  @Output() selectAddressToDeliverEvent = new EventEmitter<boolean>();
  selectedAddressName!: string;

  constructor() {}

  selectAddress():void {
    this.selectAddressToDeliverEvent.emit(true);
  }
}
